import script from "./HeaderBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderBlock.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderBlock.vue?vue&type=style&index=0&id=777adf5e&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777adf5e"]])

export default __exports__